import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

export const createNewLiveFeed = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_NEW_LIVE_FEED}`, body);

export const getAllLiveFeed = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_LIVE_FEED}`);

export const updateLiveFeed = async (body, news_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_LIVE_FEED}/${news_id}`, body);

export const getTodayLiveFeed = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_TODAY_LIVE_FEED}`);

export const deleteLiveFeed = async (news_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_LIVE_FEED}/${news_id}`);
